import { useMemo } from "react";

const parseNumericPrice = (value) => {
  if (value == null) return 0;
  const num =
    typeof value === "number"
      ? value
      : parseFloat(value.toString().replace(/[^0-9.-]/g, ""));
  return isNaN(num) ? 0 : num;
};

export default function useProductPricing(groupedProducts, haveItState, currencyInfo) {
  const { totalPrice, adjustedTotalPrice } = useMemo(() => {
    return groupedProducts.reduce(
      (acc, cat) => {
        cat.items.forEach((item) => {
          if (item.unmatched === true || item.error) return;
          const price = parseNumericPrice(item.totalPrice || "");
          acc.totalPrice += price;
          if (!haveItState[item.productName]) {
            acc.adjustedTotalPrice += price;
          }
        });
        return acc;
      },
      { totalPrice: 0, adjustedTotalPrice: 0 }
    );
  }, [groupedProducts, haveItState]);

  const formatMoney = (value) => {
    if (value == null || value === "N/A") return `${currencyInfo.symbol}0.00`;
    const num = parseNumericPrice(value);
    return `${currencyInfo.symbol}${num.toFixed(2)}`;
  };

  return {
    totalPrice,
    adjustedTotalPrice,
    formatMoney,
  };
}
